import { FloatingPortal, flip, shift, type Middleware } from "@floating-ui/react";
import { createContext, useContext } from "react";

export const FloatingPortalContext = createContext<{ root: HTMLElement, window: Window }>({ root: document.body, window: window });

/** Modal windows (e.g. {@link AdvancedDragModal}) set `root` so `MITFloatingPortal` and bounds-aware tooltips share the same DOM subtree. */
export function useFloatingPortalContext(): { root: HTMLElement, window: Window } {
   return useContext(FloatingPortalContext);
}

/** Flip + shift inside `root` (modal). Empty when no modal root — caller usually adds viewport flip/shift separately. */
export function floatingBoundaryMiddleware(root: HTMLElement | null | undefined): Middleware[] {
   if (root == null) return [];
   return [flip({ boundary: root, padding: 8 }), shift({ boundary: root, padding: 8 })];
}

export function MITFloatingPortal(props: { children: React.ReactNode }) {
   const { root } = useFloatingPortalContext();

   return (
      <FloatingPortal root={root}>
         {props.children}
      </FloatingPortal>
   )
}